module.exports = __webpack_public_path__ + "img/icn-hot-active.0d42750f.png";